/* Publish by EComposer at 2026-09-28 19:40:56*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-p72t2x35lr"]=  window.__ectimmers["ecom-p72t2x35lr"] || {};
if(!this.settings||!this.$el||this.isLive)return;const t=this.$el;let e=t.querySelectorAll('script:not([type="application/json"])');e.length>0&&e.forEach(function(i){let n=document.createElement("script");n.type="text/javascript",n.innerText=i.innerText,i.src&&(n.src=i.src),t.appendChild(n),i.remove()})

                    });
                    
                        document.querySelectorAll('.ecom-p72t2x35lr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p72t2x35lr', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8i40ilj12q5"]=  window.__ectimmers["ecom-8i40ilj12q5"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-8i40ilj12q5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8i40ilj12q5', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-1uqcd40w6rg"]=  window.__ectimmers["ecom-1uqcd40w6rg"] || {};
const t=this.$el;if(!t)return;let e=this.isLive,i=t.querySelector(".ecom-masonry-layout");if(!i)return;if(this.settings.lightbox){let a=this.$el.querySelectorAll("[ecom-modal]");a.forEach(c=>{let d=c.closest("a[href]");d&&d.addEventListener("click",function(m){e||m.preventDefault(),m.stopPropagation()},!0)}),(()=>{a.length&&window.EComModal&&new window.EComModal(a,{gallery:!0,cssClass:["ecom-container-lightbox-"+this.id]})})()}i.addEventListener("itemChange",function(){setTimeout(function(){i.masonry.layout()},500)});var o=i.getAttribute("data-ecom-packery-params")||"{}";let s=Object.assign({itemSelector:".ecom-masonry-layout__item",layoutMode:"masonry",percentPosition:!0,resize:!0},JSON.parse(o));var r=new window.EComPackery(i,s);i.masonry=r,i.querySelectorAll("img").forEach(function(a){a.addEventListener("load",function(){r.layout()})})

                    });
                    
                        document.querySelectorAll('.ecom-1uqcd40w6rg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1uqcd40w6rg', settings: {"lightbox":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}